import AboutPopup from "@/components/about-popup";
import PopupShell from "@/components/popup-shell";
import styles from "@/components/welcome-popup.module.css";
import { globals } from "@/globals";
import * as signals from "@/signals";
import { closePopup, logIn } from "@/utils";
import {
	faCode,
	faIcons,
	faImage,
	faNoteSticky,
	faSquarePlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import { JSX, useState } from "react";

interface WelcomePopupProps {
	isShown: boolean;
}

function WelcomePopup({ isShown }: WelcomePopupProps): JSX.Element {
	const [isAboutPopupShown, setIsAboutPopupShown] = useState(false);
	const [isClosing, setIsClosing] = useState(false);

	const closeAboutPopup = (): void => {
		setIsAboutPopupShown(false);
	};

	const closeWelcomePopup = (): void => {
		setIsClosing(true);
		window.setTimeout(() => {
			if (globals.isMigrationNeeded) {
				signals.arePopupsShown.value = {
					...signals.arePopupsShown.value,
					migration: true,
					welcome: false,
				};
			} else {
				if (!signals.login.value.username) {
					logIn();
				}
				closePopup("welcome");
			}
			setIsClosing(false);
		}, 350);
	};

	const showAboutPopup = (): void => {
		setIsAboutPopupShown(true);
	};

	const featureList = [
		{
			description:
				"青柠起始页 3.0 采用更先进的技术框架从零开始完全重写，性能和稳定性显著提升。",
			icon: faCode,
			title: "从零开始",
		},
		{
			description: "将您最常用的网站添加到页面底部的捷径坞。",
			icon: faSquarePlus,
			title: "全新「捷径坞」",
		},
		{
			description:
				"「便笺」经过重新设计。支持 Markdown 语法，让每一个想法清晰易读、赏心悦目。亦支持最大化窗口、实时自动保存、字数统计等新功能，让便笺编辑如行云流水般丝滑。",
			icon: faNoteSticky,
			title: "全新「便笺」",
		},
		{
			description:
				"支持一次选择多张本地图片或使用在线图片链接作为自定义壁纸。更有多张全新默认壁纸供您欣赏。",
			icon: faImage,
			title: "全新「壁纸」",
		},
		{
			description:
				"还有数十项新增功能和改进待您探索。我们致力于让青柠起始页更加完美。",
			icon: faIcons,
			title: "至善至美",
		},
	];

	const featureItems = featureList.map((item, index) => (
		<div
			className={styles["feature-item"]}
			key={index}
		>
			<FontAwesomeIcon
				fixedWidth
				icon={item.icon}
			/>
			<div>
				<div className={styles["feature-item-title"]}>{item.title}</div>
				<div className={styles["feature-item-description"]}>
					{item.description}
				</div>
			</div>
		</div>
	));

	return (
		<>
			<PopupShell
				isClosingOverride={isClosing}
				isHeadingHidden={true}
				isPureWhite={true}
				isShown={isShown}
				onClose={closeWelcomePopup}
				title="焕然一新"
			>
				<div className={styles["container"]}>
					<h1>焕然一新</h1>
					<div>欢迎来到青柠起始页 3.0</div>
					<div className={styles["feature-items-container"]}>
						{featureItems}
					</div>
					<button
						className="link"
						onClick={showAboutPopup}
						type="button"
					>
						{t("viewFullChangelog")}
					</button>
					<button
						className={styles["button"]}
						onClick={closeWelcomePopup}
						type="button"
					>
						{t("start")}
					</button>
				</div>
			</PopupShell>
			<AboutPopup
				closeAboutPopup={closeAboutPopup}
				isShown={isAboutPopupShown}
			/>
		</>
	);
}

export default WelcomePopup;
